<template>
  <div
    v-if="!$yhcefs.$userInputData.isContainUnavailableArea"
    class="yhc-ef-datetime-inputs mb-4"
  >
    <YhcEFSectionTitle>お預かり・お届け日時</YhcEFSectionTitle>
    <YhcEFSameDayDeliveryOption
      v-if="sameDayPickupAndDeliveryAvailable && !sameDayDeliveryDisabledByPeakSeason"
    />
    <div
      v-if="$yhcefs.$userInputData.address_from && $yhcefs.$userInputData.address_to"
      class="yhc-ef-datetime-inputs--inner"
    >
      <div class="yhc-ef-datetime-inputs--inner-item">
        <div>
          <h5 class="bold text-center mb-1">お預かり日時</h5>
          <p class="text-center small">{{ $yhcefs.$userInputData.address_from }}</p>
          <YhcEfDatetimePickupDate />
          <YhcEFDatetimeSelect
            :zip-code-master="$yhcefs.$userInputData.zip_from_yhc_master"
            :selectedTimeOption="$yhcefs.$userInputData.from_time_option"
            :selectedUseJustInTimeOption="$yhcefs.$userInputData.from_time_option_use_jit"
            from-or-to="from"
            @update:timeOption="(_v) => ($yhcefs.$userInputData.from_time_option = _v)"
            @update:useJustInTimeOption="
              (_useJustInTimeOption) =>
                ($yhcefs.$userInputData.from_time_option_use_jit = _useJustInTimeOption)
            "
            @update:canSelectTimeOption="(_v) => (canSelectTimeOptionFrom = _v)"
          />
        </div>
        <div
          v-if="
            !$yhcefs.$userInputData.pickupDateDisplayErrorMessage &&
            (canSelectTimeOptionFrom || isJustInTimeOptionVisibleFrom) &&
            !$yhcefs.$userInputData.isSameDayPickupAndDelivery &&
            !justInTimeDisabledByPeakSeasonFrom
          "
          class="yhc-ef-datetime-inputs--inner-notice"
        >
          ※表示価格は全て税込です。<br />
          ※時間帯指定料金について、ご不在時の返金は致しかねますので、ご注意ください。
        </div>
      </div>
      <div class="yhc-ef-datetime-inputs--inner-item">
        <div>
          <h5 class="bold text-center mb-1">お届け日時</h5>
          <p class="text-center small">{{ $yhcefs.$userInputData.address_to }}</p>
          <YhcEfDatetimeMinDeliverDate />
          <YhcEFDatetimeSelect
            :zip-code-master="$yhcefs.$userInputData.zip_to_yhc_master"
            :selectedTimeOption="$yhcefs.$userInputData.to_time_option"
            :selectedUseJustInTimeOption="$yhcefs.$userInputData.to_time_option_use_jit"
            from-or-to="to"
            @update:timeOption="(_v) => ($yhcefs.$userInputData.to_time_option = _v)"
            @update:useJustInTimeOption="
              (_useJustInTimeOption) =>
                ($yhcefs.$userInputData.to_time_option_use_jit = _useJustInTimeOption)
            "
            @update:canSelectTimeOption="(_v) => (canSelectTimeOptionTo = _v)"
          />
        </div>
        <div
          v-if="
            !$yhcefs.$userInputData.pickupDateDisplayErrorMessage &&
            (canSelectTimeOptionTo || isJustInTimeOptionVisibleTo) &&
            !$yhcefs.$userInputData.isSameDayPickupAndDelivery &&
            !justInTimeDisabledByPeakSeasonTo
          "
          class="yhc-ef-datetime-inputs--inner-notice"
        >
          ※表示価格は全て税込です。<br />
          ※時間帯指定料金について、ご不在時の返金は致しかねますので、ご注意ください。
        </div>
      </div>
    </div>
    <div
      v-else
      class="text-center"
    >
      お預かり先及びお届け先の郵便番号を入力してください。
    </div>
  </div>
</template>
<style lang="scss">
.yhc-ef-datetime-inputs {
  .yhc-ef-datetime-inputs--inner {
    display: flex;
    justify-content: center;
    gap: var(--yhc-base-pad-xl);
    flex-wrap: wrap;

    .yhc-ef-datetime-inputs--inner-notice {
      font-size: 13px;
      text-align: left;
      padding-left: 0.25rem;
    }
  }

  .yhc-ef-datetime-inputs--inner-item--pickup-date-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--yhc-pad);
    padding: var(--yhc-pad);
    background-color: var(--bs-gray-200);
    font-weight: bold;
    flex-wrap: wrap;

    .yhc-ef-datetime-inputs--inner-item--pickup-date-info--label {
      width: 100px;
    }

    .yhc-ef-datetime-inputs--inner-item--pickup-date-info--dates {
      text-align: right;
    }
  }

  .yhc-ef-datetime-inputs--inner-item--pickup-date-info--desc {
    font-size: 12px;
    font-weight: normal;
    padding-top: var(--yhc-pad-sm);
    width: 100%;
  }

  .yhc-ef-datetime-inputs--inner-item {
    max-width: 380px;
    background-color: white;
    box-shadow: var(--yhc-box-shadow-strong);
    border-radius: var(--yhc-border-radius);
    padding: var(--yhc-pad);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>

<script lang="ts">
import YhcEFDatetimeSelect from './YhcEFDatetimeSelect.vue'
import { YhcEstimateFormFrontService } from '../../YhcEstimateFormFrontService'
import YhcEfDatetimePickupDate from './YhcEfDatetimePickupDate.vue'
import YhcEfDatetimeMinDeliverDate from './YhcEfDatetimeMinDeliverDate.vue'
import YhcEFSameDayDeliveryOption from './YhcEFSameDayDeliveryOption.vue'
import { ModelYhcKazaiDeliveryPeakSeasonRules } from '../../../../fireModels/yhcDataTypes'
import { yhcEFTimeOptionsByTimeBandCode } from '../../YhcEFUserInputDataHandler'
import { overDeliverableItemCountsMessage } from '../peakSeasonAlertMessages'
import {
  deliverableItemCountsModalListItemHtml,
  hasPeakSeasonRule,
  isDeliverableItemCountsExceeded,
} from '../peakSeasonRuleUtils'
import { formatDateForMD } from './dateFormatter'

export default {
  name: 'YhcEFDatetimeInputs',
  components: {
    YhcEfDatetimeMinDeliverDate,
    YhcEfDatetimePickupDate,
    YhcEFDatetimeSelect,
    YhcEFSameDayDeliveryOption,
  },
  inject: ['YhcEstimateFormFrontServiceInstance'],
  data() {
    return {
      canSelectTimeOptionFrom: false,
      canSelectTimeOptionTo: false,
      isSameDayPickupAndDelivery: false,
      isInitialMount: true,
    }
  },
  computed: {
    $yhcefs(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
    sameDayPickupAndDeliveryAvailable(): boolean {
      // 当日自発着可能なエリアかどうか（お預かり先とお届け先の市区名が同一で双方当日自発着可能フラグTrueの場合）
      return this.$yhcefs.$userInputData.sameDayPickupAndDeliveryAvailable
    },
    sameDayPickupAndDeliveryFee(): number {
      return this.$yhcefs.generalOptionsByKey['same_day_delivery'].price
    },
    deliveryPeakSeasonRule(): ModelYhcKazaiDeliveryPeakSeasonRules | undefined {
      // お預かり日～お届け日が繁忙期シーズンルールの開始日～終了日に含まれていれば、そのルールマスタを返す
      return this.$yhcefs.$userInputData.deliveryPeakSeasonRule
    },
    sameDayDeliveryDisabledByPeakSeason(): boolean {
      return !!this.deliveryPeakSeasonRule?.sameDayDeliveryDisabled
    },
    justInTimeDisabledByPeakSeasonFrom(): boolean {
      // お預かり日が繁忙期に掛かっており、且つジャストオンタイムオプションが無効
      return (
        this.$yhcefs.$userInputData.pickupDateInPeakSeason &&
        !yhcEFTimeOptionsByTimeBandCode[
          this.$yhcefs.$userInputData.zip_from_yhc_master?.timeBand
        ]?.justInTimeOption
      )
    },
    justInTimeDisabledByPeakSeasonTo(): boolean {
      // お届け日が繁忙期に掛かっており、且つジャストオンタイムオプションが無効
      return (
        this.$yhcefs.$userInputData.deliveryDateInPeakSeason &&
        !yhcEFTimeOptionsByTimeBandCode[
          this.$yhcefs.$userInputData.zip_to_yhc_master?.timeBand
        ]?.justInTimeOption
      )
    },
    isJustInTimeOptionVisibleFrom(): boolean {
      if (this.$yhcefs.$userInputData.isSameDayPickupAndDelivery) {
        return false
      }
      const jitKey =
        yhcEFTimeOptionsByTimeBandCode[
          this.$yhcefs.$userInputData.zip_from_yhc_master?.timeBand
        ]?.justInTimeOption?.price
      return !!(jitKey && this.$yhcefs.generalOptionsByKey[jitKey]?.price)
    },
    isJustInTimeOptionVisibleTo(): boolean {
      if (this.$yhcefs.$userInputData.isSameDayPickupAndDelivery) {
        return false
      }
      const jitKey =
        yhcEFTimeOptionsByTimeBandCode[
          this.$yhcefs.$userInputData.zip_to_yhc_master?.timeBand
        ]?.justInTimeOption?.price
      return !!(jitKey && this.$yhcefs.generalOptionsByKey[jitKey]?.price)
    },
  },
  watch: {
    sameDayDeliveryDisabledByPeakSeason: {
      handler() {
        this.checkedOutSameDayPickup()
      },
      immediate: false,
    },
    deliveryPeakSeasonRule: {
      handler(newValue, oldValue) {
        const hadRule = hasPeakSeasonRule(oldValue)
        const hasRule = hasPeakSeasonRule(newValue)
        let showedModal = false

        // 繁忙期シーズン外から繁忙期シーズン内に変更されたとき、モーダルでアラートを表示する
        if (!hadRule && hasRule && !this.isInitialMount) {
          this.showModalForPeakSeason()
          showedModal = true
        }

        // 移行モーダルが出ない場合のみ（繁忙期A→B切替等）、既存家財点数を再チェック
        if (!showedModal && hasRule && !this.isInitialMount) {
          this.alertIfDeliverableItemCountsExceeded(newValue)
        }

        if (this.isInitialMount) {
          this.isInitialMount = false
        }
      },
      immediate: true,
    },
    '$yhcefs.$userInputData.isSameDayPickupAndDelivery': {
      handler(newValue) {
        // 当日自発着利用チェックが入っていて、繁忙期シーズンに日付変更した際アラートメッセージ表示するための処置
        // '$yhcefs.$userInputData.isSameDayPickupAndDelivery'をそのまま使うと処理順序で不具合が生じるため
        if (newValue) {
          this.isSameDayPickupAndDelivery = newValue
        }
      },
      immediate: true,
    },
  },
  methods: {
    checkedOutSameDayPickup() {
      this.$yhcefs.$userInputData.sameDayPickupAndDeliveryUseChange(false)
    },
    alertIfDeliverableItemCountsExceeded(
      rule: ModelYhcKazaiDeliveryPeakSeasonRules | undefined,
    ) {
      if (!hasPeakSeasonRule(rule)) return
      const itemCount = Object.keys(
        this.$yhcefs.$userInputData.userAddedKazaiDataById,
      ).length
      if (!isDeliverableItemCountsExceeded(rule, itemCount)) return
      const message = overDeliverableItemCountsMessage(rule)
      if (message) {
        $core.$toast.alertDialog(message, {})
      }
    },
    showModalForPeakSeason() {
      const rule = this.deliveryPeakSeasonRule
      if (!hasPeakSeasonRule(rule)) return

      let message = `<span style="color: red;">${formatDateForMD(
        rule.startDate,
      )}～${formatDateForMD(
        rule.endDate,
      )}</span>は引越シーズンとなるため以下の対応とさせていただきます。<ul class="mt-2">`
      message += `<li>シーズン加算料金として <span class="bold" style="color: red;">+¥${rule.additionalPrice.toLocaleString()}</span> (税込) /件が発生します。</li>`
      message += `<li><span class="bold" style="color: red;">時間帯指定はできません。</span></li>`
      const pointsLi = deliverableItemCountsModalListItemHtml(rule)
      if (pointsLi) {
        message += `<li>${pointsLi}</li>`
      }
      message += `<li>当日15時までの事前予約で、最短翌々日のお預かりが可能です。</li>`

      // 当日自発着利用チェックを入れていて、かつ繁忙期シーズンルール上当日自発着利用不可だった場合の追加メッセージ
      if (this.isSameDayPickupAndDelivery && this.sameDayDeliveryDisabledByPeakSeason) {
        message += `<li style="color: red;">お預かり日当日の配達は利用できません</li>`
      }
      message += `</ul>`
      $core.$toast.alertDialog(message, {})
      this.isSameDayPickupAndDelivery = false
    },
  },
}
</script>
